import * as pdfjsLib from "pdfjs-dist/build/pdf.mjs";

// Use the local worker file bundled with pdfjs-dist to avoid CDN CORS issues.
// The .mjs worker is served as a static asset via webpack.
pdfjsLib.GlobalWorkerOptions.workerSrc =
  "https://cdn.jsdelivr.net/npm/pdfjs-dist@4.10.38/build/pdf.worker.min.mjs";

/**
 * Render a single page of a PDF (from an ArrayBuffer) to a PNG data URL.
 * @param {ArrayBuffer} arrayBuffer - PDF bytes
 * @param {number} pageNum - 1-based page index
 * @param {number} maxWidth - target render width (auto-scales retina)
 * @returns {Promise<{ dataUrl: string, numPages: number, width: number, height: number }>}
 */
export async function renderPdfPageToDataUrl(arrayBuffer, pageNum = 1, maxWidth = 2000) {
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
  const numPages = pdf.numPages;
  const page = await pdf.getPage(Math.min(Math.max(pageNum, 1), numPages));
  const viewport1 = page.getViewport({ scale: 1 });
  const scale = Math.min(maxWidth / viewport1.width, 3);
  const viewport = page.getViewport({ scale });

  const canvas = document.createElement("canvas");
  canvas.width = Math.floor(viewport.width);
  canvas.height = Math.floor(viewport.height);
  const ctx = canvas.getContext("2d");

  await page.render({ canvasContext: ctx, viewport }).promise;
  return {
    dataUrl: canvas.toDataURL("image/png"),
    numPages,
    width: canvas.width,
    height: canvas.height,
  };
}
